<div class="navigation-item-wrapper" [class.active]="isActive">
  <span class="navigation-item-label">{{ name }}</span>
  <div *ngIf="itemsCount" class="item-count-wrapper">{{itemsCount}}</div>
</div>
